export default __webpack_public_path__ + "static/media/InfoTooltip.c9fabb94.svg";